export const bookCategories = [
  "All",
  "Literature & Novels",
  "Philosophy & Ideas",
  "History & Geopolitics",
  "Statecraft & Polity",
  "Physics & Core Science"
];

export const bookshelf = [
  // =========================================================================
  // 10 CLASSIC & MODERN NOVELS (LITERATURE)
  // =========================================================================
  {
    id: "crime-and-punishment",
    slug: "crime-and-punishment",
    title: "Crime and Punishment",
    author: "Fyodor Dostoevsky",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 430,
    language: "English",
    description: "A psychological masterpiece exploring moral dilemmas, guilt, redemption, and the rationalization of crime through the troubled mind of Rodion Raskolnikov in St. Petersburg.",
    notes: "Profound dissection of the 'extraordinary man' theory, human conscience, and the inevitable psychological collapse that follows transgression."
  },
  {
    id: "1984",
    slug: "1984",
    title: "1984",
    author: "George Orwell",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 328,
    language: "English",
    description: "The definitive dystopian novel depicting a totalitarian regime under Big Brother that exercises total control over language, memory, truth, and individual thought.",
    notes: "Chilling analysis of Newspeak, doublethink, and state surveillance. Essential reading for understanding information control and institutional power."
  },
  {
    id: "brave-new-world",
    slug: "brave-new-world",
    title: "Brave New World",
    author: "Aldous Huxley",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 288,
    language: "English",
    description: "A visionary dystopian novel set in a technologically controlled World State where citizens are genetically engineered, conditioned, and pacified by pleasure and consumption.",
    notes: "Fascinating contrast to Orwell: Huxley foresaw a dystopia created not by state violence, but by voluntary surrender to superficial entertainment and conditioning."
  },
  {
    id: "the-brothers-karamazov",
    slug: "the-brothers-karamazov",
    title: "The Brothers Karamazov",
    author: "Fyodor Dostoevsky",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2024",
    pages: 796,
    language: "English",
    description: "Dostoevsky's magnum opus exploring faith, free will, morality, and family drama centered on the murder of Fyodor Pavlovich Karamazov and his four sons.",
    notes: "The 'Grand Inquisitor' chapter stands as one of the most brilliant theological and philosophical debates on human liberty vs. security ever written."
  },
  {
    id: "to-kill-a-mockingbird",
    slug: "to-kill-a-mockingbird",
    title: "To Kill a Mockingbird",
    author: "Harper Lee",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 336,
    language: "English",
    description: "A Pulitzer Prize-winning classic portraying racial injustice, moral courage, and empathy in the American South through the eyes of young Scout Finch and her lawyer father Atticus.",
    notes: "A timeless exploration of moral integrity in the face of societal prejudice. 'You never really understand a person until you consider things from his point of view.'"
  },
  {
    id: "the-metamorphosis",
    slug: "the-metamorphosis",
    title: "The Metamorphosis",
    author: "Franz Kafka",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 120,
    language: "English",
    description: "The existential novella of Gregor Samsa, a traveling salesman who wakes up one morning transformed into a monstrous insect, examining alienation and modern labor.",
    notes: "Haunting allegory on utility, familial dependency, and modern alienation when an individual can no longer serve economic functions."
  },
  {
    id: "the-great-gatsby",
    slug: "the-great-gatsby",
    title: "The Great Gatsby",
    author: "F. Scott Fitzgerald",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 180,
    language: "English",
    description: "Set in the Jazz Age on Long Island, exploring the elusive nature of the American Dream, unrequited love, wealth, and moral decay through Jay Gatsby's tragedy.",
    notes: "Immaculate prose and symbolism on the tragedy of idealizing the past and the hollow nature of consumer aristocracy."
  },
  {
    id: "one-hundred-years-of-solitude",
    slug: "one-hundred-years-of-solitude",
    title: "One Hundred Years of Solitude",
    author: "Gabriel García Márquez",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2024",
    pages: 417,
    language: "English",
    description: "The magical realist epic chronicle of seven generations of the Buendía family in the mythical town of Macondo, intertwining memory, cyclical history, and solitude.",
    notes: "Masterful handling of cyclical historical time, memory loss, and human solitude. A cornerstone of Latin American literature."
  },
  {
    id: "the-fountainhead",
    slug: "the-fountainhead",
    title: "The Fountainhead",
    author: "Ayn Rand",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 720,
    language: "English",
    description: "The story of uncompromising modernist architect Howard Roark, who battles institutional mediocrity and conformity to protect his creative sovereignty and vision.",
    notes: "Strong manifesto on creative autonomy, first-principles design, and uncompromising individual vision against institutional inertia."
  },
  {
    id: "animal-farm",
    slug: "animal-farm",
    title: "Animal Farm",
    author: "George Orwell",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 112,
    language: "English",
    description: "A sharp allegorical novella reflecting the events leading up to the Russian Revolution and the totalitarian corruption of revolutionary ideals by power.",
    notes: "Brilliant political satire on how revolutionary principles get steadily rewritten by ruling elites: 'All animals are equal, but some animals are more equal than others.'"
  },

  // =========================================================================
  // SCANNED PERSONAL LIBRARY: SCIENCE & COSMOLOGY
  // =========================================================================
  {
    id: "a-brief-history-of-time",
    slug: "a-brief-history-of-time",
    title: "A Brief History of Time",
    author: "Stephen Hawking",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 240,
    publisher: "Bantam",
    language: "English",
    description: "A landmark exploration of cosmology, black holes, the Big Bang, general relativity, quantum mechanics, and the search for a unified theory of physics.",
    notes: "Lucid explanations of spacetime curvature, singularity theorems, Hawking radiation, and the arrow of cosmological time."
  },

  // =========================================================================
  // SCANNED PERSONAL LIBRARY: HISTORY & GEOPOLITICS
  // =========================================================================
  {
    id: "sapiens-brief-history-of-humankind",
    slug: "sapiens-brief-history-of-humankind",
    title: "Sapiens: A Brief History of Humankind",
    author: "Yuval Noah Harari",
    category: "History & Geopolitics",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 512,
    publisher: "Vintage",
    language: "English",
    description: "An evolutionary history of humanity exploring how cognitive revolutions, shared fictions (money, religion, nations), and agriculture allowed Homo sapiens to dominate Earth.",
    notes: "Powerful thesis on inter-subjective realities (myths, legal corporations, currency) as the foundational coordination mechanism for large-scale human cooperation."
  },
  {
    id: "india-that-is-bharat",
    slug: "india-that-is-bharat",
    title: "India, That Is Bharat: Coloniality, Civilisation, Constitution",
    author: "J. Sai Deepak",
    category: "History & Geopolitics",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 484,
    publisher: "Bloomsbury India",
    language: "English",
    description: "A rigorous exploration of the influence of European colonial consciousness on Indian society, legal frameworks, and constitutional history.",
    notes: "In-depth jurisprudential deconstruction of coloniality vs. colonialism, religious liberty, and civilizational identity in constitutional law."
  },
  {
    id: "india-bharat-and-pakistan",
    slug: "india-bharat-and-pakistan",
    title: "India, Bharat and Pakistan: The Constitutional Journey of a Sandwiched Civilisation",
    author: "J. Sai Deepak",
    category: "History & Geopolitics",
    cover: null,
    status: "READ",
    yearRead: "2024",
    pages: 484,
    publisher: "Bloomsbury India",
    language: "English",
    description: "The second volume tracing the geopolitical, ideological, and constitutional trajectories that led to the partition of the Indian subcontinent.",
    notes: "Detailed historical documentation of legislative councils, communal representation, and constitutional evolution in pre-independence India."
  },
  {
    id: "the-india-way",
    slug: "the-india-way",
    title: "The India Way: Strategies for an Uncertain World",
    author: "S. Jaishankar",
    category: "History & Geopolitics",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 240,
    publisher: "HarperCollins India",
    language: "English",
    description: "Strategic analysis of India's foreign policy in a transitioning multipolar global order, balancing plurilateralism, geopolitical hedging, and national interest.",
    notes: "Insightful framework on navigating contemporary multipolar geopolitics: engaging multiple poles simultaneously while advancing sovereign strategic autonomy."
  },

  // =========================================================================
  // SCANNED PERSONAL LIBRARY: PHILOSOPHY & IDEAS
  // =========================================================================
  {
    id: "the-art-of-war",
    slug: "the-art-of-war",
    title: "The Art of War",
    author: "Sun Tzu",
    category: "Philosophy & Ideas",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 64,
    publisher: "Penguin India",
    language: "English",
    description: "Ancient military treatise on strategy, positioning, intelligence, deception, and achieving victory with minimal friction.",
    notes: "Foundational principles on asymmetry, information supremacy, discipline, and avoiding protracted conflicts."
  },
  {
    id: "politics-aristotle",
    slug: "politics-aristotle",
    title: "Politics",
    author: "Aristotle",
    category: "Philosophy & Ideas",
    cover: null,
    status: "READ",
    yearRead: "2023",
    publisher: "Penguin Classics",
    language: "English",
    description: "Aristotle's foundational philosophical treatise on the origins of the state, citizenship, constitutional forms, justice, and the common good.",
    notes: "Analysis of man as a 'political animal' (*zoon politikon*), constitutional typologies (monarchy, aristocracy, polity), and mechanisms preventing factional decay."
  },
  {
    id: "arthashastra",
    slug: "arthashastra",
    title: "Arthashastra",
    author: "Kautilya (Chanakya)",
    category: "Philosophy & Ideas",
    cover: null,
    status: "READING",
    yearRead: "2024",
    pages: 832,
    publisher: "Penguin Classics",
    language: "English",
    description: "Comprehensive ancient treatise on statecraft, economic policy, treasury management, civil administration, jurisprudence, and intelligence networks.",
    notes: "Astonishingly modern in its systematic treatment of institutional statecraft, economic regulation, taxation, and the Mandala theory of foreign relations."
  },
  {
    id: "the-story-of-philosophy",
    slug: "the-story-of-philosophy",
    title: "The Story of Philosophy",
    author: "Will Durant",
    category: "Philosophy & Ideas",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 528,
    publisher: "Pocket Books",
    language: "English",
    description: "A narrative survey of the lives and ideas of major Western philosophers from Plato and Aristotle through Spinoza, Voltaire, Kant, Schopenhauer, and Nietzsche.",
    notes: "Vivid, accessible exposition connecting biographical context with philosophical systems and epistemological inquiries."
  },
  {
    id: "a-history-of-western-philosophy",
    slug: "a-history-of-western-philosophy",
    title: "A History of Western Philosophy",
    author: "Bertrand Russell",
    category: "Philosophy & Ideas",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 895,
    language: "English",
    description: "Russell's panoramic, analytical history of Western philosophical thought from the Pre-Socratics to 20th-century logical analysis.",
    notes: "Rigorous logical breakdown of historical philosophy contextualized against social and political circumstances of each era."
  },
  {
    id: "an-introduction-to-indian-philosophy",
    slug: "an-introduction-to-indian-philosophy",
    title: "An Introduction to Indian Philosophy",
    author: "Satischandra Chatterjee & Dhirendramohan Datta",
    category: "Philosophy & Ideas",
    cover: null,
    status: "READ",
    yearRead: "2024",
    pages: 464,
    publisher: "Motilal Banarsidass",
    language: "English",
    description: "A lucid, comprehensive introduction to the nine classical systems of Indian philosophy (Nyaya, Vaisheshika, Sankhya, Yoga, Mimamsa, Vedanta, Carvaka, Jaina, and Bauddha).",
    notes: "Clear epistemological comparison (Pramanas) between Astika (orthodox) and Nastika (heterodox) schools of classical Indian thought."
  },
  {
    id: "introduction-to-religious-philosophy",
    slug: "introduction-to-religious-philosophy",
    title: "Introduction to Religious Philosophy",
    author: "Y. Masih",
    category: "Philosophy & Ideas",
    cover: null,
    status: "READ",
    yearRead: "2024",
    pages: 342,
    publisher: "Motilal Banarsidass",
    language: "English",
    description: "An analytical study of religion covering theism, proofs of God, problem of evil, religious language, and phenomenological approaches.",
    notes: "Deep examination of linguistic analysis in religious statements, verificationism, and existential teleological arguments."
  },

  // =========================================================================
  // SCANNED PERSONAL LIBRARY: STATECRAFT & POLITY (UPSC / GOVERNANCE)
  // =========================================================================
  {
    id: "indian-polity-laxmikanth",
    slug: "indian-polity-laxmikanth",
    title: "Indian Polity",
    author: "M. Laxmikanth",
    category: "Statecraft & Polity",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 804,
    publisher: "McGraw Hill (7th Edition)",
    language: "English",
    description: "The definitive benchmark text covering the Indian Constitution, parliamentary structure, executive powers, judiciary, constitutional bodies, and federal dynamics.",
    notes: "Complete architectural breakdown of constitutional articles, statutory frameworks, judicial review, and amendments."
  },
  {
    id: "governance-in-india",
    slug: "governance-in-india",
    title: "Governance in India",
    author: "M. Laxmikanth",
    category: "Statecraft & Polity",
    cover: null,
    status: "READ",
    yearRead: "2023",
    publisher: "McGraw Hill",
    language: "English",
    description: "Comprehensive coverage of administrative machinery, citizen charters, e-governance initiatives, civil service accountability, and policy formulation.",
    notes: "Systemic study of bureaucratic accountability, RTI mechanisms, public service delivery reforms, and regulatory governance."
  },
  {
    id: "constitution-of-india",
    slug: "constitution-of-india",
    title: "The Constitution of India (Bare Act & Annotations)",
    author: "Constitutional Text / Government of India",
    category: "Statecraft & Polity",
    cover: null,
    status: "READ",
    yearRead: "2023",
    language: "English",
    description: "Primary legal text containing all Articles, Parts, and Schedules of the sovereign Constitution of India.",
    notes: "Direct reference for Fundamental Rights (Part III), Directive Principles (Part IV), Emergency Provisions, and Union-State relations."
  },
  {
    id: "indian-art-and-culture",
    slug: "indian-art-and-culture",
    title: "Indian Art & Culture",
    author: "Nitin Singhania",
    category: "Statecraft & Polity",
    cover: null,
    status: "READ",
    yearRead: "2023",
    publisher: "McGraw Hill Education",
    language: "English",
    description: "In-depth study of Indian architecture, temple styles, numismatics, classical dances, music traditions, philosophy, and heritage preservation.",
    notes: "Detailed taxonomic breakdown of Nagara, Dravida, and Vesara architectural idioms and cultural evolution across dynasties."
  },
  {
    id: "international-relations-pavneet",
    slug: "international-relations-pavneet",
    title: "International Relations for Civil Services",
    author: "Pavneet Singh",
    category: "Statecraft & Polity",
    cover: null,
    status: "READ",
    yearRead: "2023",
    publisher: "McGraw Hill",
    language: "English",
    description: "Analysis of India's bilateral relations, global multilateral institutions (UN, WTO, IMF), neighborhood policies, and contemporary international affairs.",
    notes: "Strategic perspective on maritime security, Quad, SCO, BRICS, and energy security diplomacy."
  },
  {
    id: "lexicon-ethics-integrity-aptitude",
    slug: "lexicon-ethics-integrity-aptitude",
    title: "The Lexicon for Ethics, Integrity and Aptitude",
    author: "N. N. Ojha & Niraj Kumar",
    category: "Statecraft & Polity",
    cover: null,
    status: "READ",
    yearRead: "2023",
    publisher: "Chronicle Books",
    language: "English",
    description: "Core conceptual terminology, ethical theories, moral philosophers, and case studies for administrative ethics and integrity.",
    notes: "Structured glossary of ethical vocabulary, deontology vs. consequentialism, and probity in governance."
  },
  {
    id: "environment-shankar-ias",
    slug: "environment-shankar-ias",
    title: "Environment & Ecology",
    author: "Shankar IAS Academy",
    category: "Statecraft & Polity",
    cover: null,
    status: "READ",
    yearRead: "2023",
    pages: 400,
    publisher: "Shankar IAS Academy",
    language: "English",
    description: "Comprehensive reference on ecological principles, biodiversity conservation, climate change accords (UNFCCC, COP), pollution, and environmental law.",
    notes: "Essential compendium on ecosystem trophic dynamics, wetland conservation (Ramsar), Wildlife Protection Act, and renewable transitions."
  },
  {
    id: "upsc-prelims-pyqs",
    slug: "upsc-prelims-pyqs",
    title: "26 Years UPSC CSE Prelims PYQs Solved Compendium",
    author: "Civil Services Editorial Board",
    category: "Statecraft & Polity",
    cover: null,
    status: "READ",
    yearRead: "2023",
    language: "English",
    description: "Topic-wise question bank and analytical solutions spanning 26 years of civil services examinations.",
    notes: "Pattern analysis of conceptual trends across polity, history, economy, geography, and general science."
  },
  {
    id: "ias-mains-general-studies-solved",
    slug: "ias-mains-general-studies-solved",
    title: "IAS Mains General Studies: Solved Papers (1997–2021)",
    author: "Chronicle & Editorial Experts",
    category: "Statecraft & Polity",
    cover: null,
    status: "READ",
    yearRead: "2023",
    language: "English",
    description: "Comprehensive archive of solved Mains subjective question papers across GS Papers I, II, III, and IV.",
    notes: "Model structured answers emphasizing multi-dimensional analysis, institutional solutions, and constitutional referencing."
  },

  // =========================================================================
  // SCANNED PERSONAL LIBRARY: PHYSICS, CHEMISTRY & COMPETITIVE SCIENCES (JEE/NDA)
  // =========================================================================
  {
    id: "concepts-of-physics-vol-1",
    slug: "concepts-of-physics-vol-1",
    title: "Concepts of Physics (Part 1)",
    author: "Dr. H. C. Verma",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 461,
    publisher: "Bharati Bhawan",
    language: "English",
    description: "The seminal Indian physics textbook covering classical mechanics, kinematics, Newton's laws, gravitation, fluids, and wave optics with intuitive first principles.",
    notes: "Masterful pedagogy teaching physical intuition, free-body diagram analysis, and dimensional verification."
  },
  {
    id: "concepts-of-physics-vol-2",
    slug: "concepts-of-physics-vol-2",
    title: "Concepts of Physics (Part 2)",
    author: "Dr. H. C. Verma",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 466,
    publisher: "Bharati Bhawan",
    language: "English",
    description: "Part 2 covering thermodynamics, electrostatics, magnetostatics, electromagnetism, and atomic & nuclear modern physics.",
    notes: "Brilliant conceptual problems on electric flux, electromagnetic induction, and quantum photon interactions."
  },
  {
    id: "problems-in-general-physics-irodov",
    slug: "problems-in-general-physics-irodov",
    title: "Problems in General Physics",
    author: "I. E. Irodov",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 386,
    publisher: "Mir Publishers",
    language: "English",
    description: "Legendary Russian problem-solving book featuring advanced mathematical physics problems across mechanics, electrodynamics, thermodynamics, and optics.",
    notes: "The gold standard for rigorous calculus-based physics problem solving and differential equation modeling."
  },
  {
    id: "physics-galaxy-ashish-arora",
    slug: "physics-galaxy-ashish-arora",
    title: "Physics Galaxy Series",
    author: "Ashish Arora",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    publisher: "G.K. Publications",
    language: "English",
    description: "Deep problem collection and visual physics breakdowns for advanced engineering entrance examinations.",
    notes: "Excellent step-by-step visual problem dissection and rotational dynamics analysis."
  },
  {
    id: "problems-in-physical-chemistry-awasthi",
    slug: "problems-in-physical-chemistry-awasthi",
    title: "Problems in Physical Chemistry for JEE Advanced",
    author: "Narendra Awasthi",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 600,
    publisher: "Shri Balaji Publications",
    language: "English",
    description: "Rigorous quantitative problem compendium covering chemical thermodynamics, chemical kinetics, electrochemistry, and ionic equilibria.",
    notes: "Exhaustive calculations on thermodynamic state functions, rate laws, and buffer equilibrium mathematics."
  },
  {
    id: "advanced-problems-in-physical-chemistry-neeraj",
    slug: "advanced-problems-in-physical-chemistry-neeraj",
    title: "Advanced Problems in Physical Chemistry",
    author: "Neeraj Kumar",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 528,
    publisher: "Pearson India",
    language: "English",
    description: "Advanced numerical and analytical problem sets in physical chemistry for competitive examinations.",
    notes: "Deep problem sets on solid state crystallography and phase equilibria."
  },
  {
    id: "advanced-problems-in-organic-chemistry-chouhan",
    slug: "advanced-problems-in-organic-chemistry-chouhan",
    title: "Advanced Problems in Organic Chemistry",
    author: "M. S. Chouhan",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    publisher: "Shri Balaji Publications",
    language: "English",
    description: "Advanced mechanistic problem book covering organic reaction mechanisms, stereochemistry, rearrangements, and multi-step synthesis.",
    notes: "Intricate arrow-pushing mechanisms for carbocation rearrangements, nucleophilic substitutions, and pericyclic reactions."
  },
  {
    id: "pathfinder-nda-na",
    slug: "pathfinder-nda-na",
    title: "Pathfinder NDA/NA Examination",
    author: "Arihant Experts",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    pages: 1306,
    publisher: "Arihant Publications India",
    language: "English",
    description: "Comprehensive national defense entrance compendium covering higher mathematics, general science, English, and general knowledge.",
    notes: "Wide-ranging curriculum synthesis across algebra, trigonometry, vectors, and physics."
  },
  {
    id: "high-school-english-grammar-wren-martin",
    slug: "high-school-english-grammar-wren-martin",
    title: "High School English Grammar and Composition",
    author: "P. C. Wren & H. Martin",
    category: "Literature & Novels",
    cover: null,
    status: "READ",
    yearRead: "2022",
    publisher: "S. Chand",
    language: "English",
    description: "The quintessential, authoritative reference grammar textbook covering syntax, clause analysis, idiom usage, and structured composition.",
    notes: "Foundational rules on sentence transformation, synthesis of sentences, and precise vocabulary."
  },
  {
    id: "advanced-mathematics-competitive",
    slug: "advanced-mathematics-competitive",
    title: "Advanced Mathematics & Calculus for Competitive Examinations",
    author: "Higher Mathematics Editorial Board",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    language: "English",
    description: "Comprehensive problem sets in differential and integral calculus, coordinate geometry, linear algebra, and complex numbers.",
    notes: "Core reference for limits, integration techniques, conic sections, and algebraic transformations."
  },
  {
    id: "quantitative-arithmetic-compendium",
    slug: "quantitative-arithmetic-compendium",
    title: "Quantitative Aptitude & Arithmetic",
    author: "Arihant Editorial Board",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    language: "English",
    description: "Applied arithmetic, number theory, permutations and combinations, probability, and speed mathematics techniques.",
    notes: "Fast mental arithmetic strategies and combinatorial counting principles."
  },
  {
    id: "biology-foundations-xam-idea",
    slug: "biology-foundations-xam-idea",
    title: "Foundations of Biological Sciences & Genetics",
    author: "Xam Idea / Science Editorial Board",
    category: "Physics & Core Science",
    cover: null,
    status: "READ",
    yearRead: "2022",
    language: "English",
    description: "Core biological systems covering cell biology, molecular genetics, biotechnology, human physiology, and evolution.",
    notes: "Detailed structural diagrams of DNA replication, transcription, protein synthesis, and physiological homeostasis."
  }
];
